/**
 * Returns the most useful message from the different error shapes returned by
 * the API client and service methods.
 */
export const getApiErrorMessage = (error, fallback = '') => {
  if (!error) return fallback;

  const message =
    error?.apiMessage ??
    error?.response?.message ??
    error?.response?.data?.message ??
    error?.data?.message ??
    error?.message;

  return message || fallback;
};

export default getApiErrorMessage;
